module.exports = __webpack_public_path__ + "img/compare-fixed.98e043da.svg";